import {useMemo} from "react";
import {useSelector} from "react-redux";
import {skipToken} from "@reduxjs/toolkit/query/react";
import {useGetDrillholesQuery} from "../../redux/rtk/drillholeApi";
import {RootState} from "../../redux/store";

export const useDrillholeData = () => {
    const projectId = useSelector((state: RootState) => state.project.selectedProject?.project_id);
    const {data, isLoading, error} = useGetDrillholesQuery(projectId ?? skipToken);

    const {withCoords, withoutCoords} = useMemo(() => {
        if (!data) return {withCoords: [], withoutCoords: []};

        const withCoords: any[] = [];
        const withoutCoords: any[] = [];

        for (const drillhole of data) {
            if (drillhole.collar && drillhole.collar.LONGITUDE != null && drillhole.collar.LATITUDE != null) {
                withCoords.push(drillhole);
            } else {
                withoutCoords.push(drillhole);
            }
        }

        return {withCoords, withoutCoords};
    }, [data]);

    return {data: data || [], withCoords, withoutCoords, isLoading, error};
};
